import React, { useState, useEffect } from "react";
import "../../Style.css";
import Utils from "../../core/Utils";
import UserHelper from "../../core/UserHelper";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { connectToStore } from "../../data/store";
import SideBarMenuItems from "../SideBarMenuItems";
import SettingsMenuItems from "../SettingsMenuItems";
import ReportMenuItems from "../ReportMenuItems";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import {
  SideBarMenuNames,
  SettingsMenuList,
  ReportMaxDateLimit,
} from "../../core/Constants";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MessagePopup from "../common/MessagePopUp";
import { Typography } from "@mui/material";
import { Grid, Box, Container, Stack, Switch } from "@mui/material";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import Loader from "../common/Loader";
import moment from "moment";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { ExpensesReportPage, LoginPage } from "../../core/PageConstants";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import { getBusiness } from "../../data/localSettingsActions";
import { postAsync } from "../../core/serviceClient";
import { UserRoles } from "../../core/Constants";
import CountryHelper from "../../core/CountryHelper";
import SendIcon from '@mui/icons-material/Send';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ClearIcon from '@mui/icons-material/Clear';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const ExpensesReport = (props) => {
  document.title = "Expenses ";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [showMethod, setShowMethod] = useState("");
  const [reportContent, setReportContent] = useState("");
  const [filterByBranch, setFilterByBranch] = useState(false);
  const [filterByPaymentType, setFilterByPaymentType] = useState(false);
  const [vendorPaymentStatus, setVendorPaymentStatus] = useState("");
  const [selectedDate, setSelectedDate] = useState([
    Utils.GetStartDate(),
    Utils.GetEndDate(),
  ]);
  const [localSettings, setLocalSettings] = useState(connectToStore());
  const [statementMethod, setStatementMethod] = useState("Summary");
  const [_IsDetailed, setIsDetailed] = useState(false);
  const [emailId, setEmailId] = useState("");
  const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branches, setBranches] = useState([]);
  const [isUAEBusiness, setIsUAEBusiness] = useState(false);

  const handleFilterByBranchChange = (event) => {
    setFilterByBranch(event.target.checked);
  };
  const handleFilterByPaymentChange = (event) => {
    setFilterByPaymentType(event.target.checked);
  }

  const handleMsgClose = () => {
    setMsgOpen(false);
    if (isNavigateToLogin) {
      UserHelper.LogOut(dispatch);
      navigate(LoginPage.Path);
    }
  };

  const handleSubmit = () => {
    setShowMethod(statementMethod);
    getStatementStatus(statementMethod);
  };

  const getStatementStatus = async (statementMethod) => {
    setIsLoading(true);
    let url = "reports/GetExpenseDetailed?";
    const branchId = selectedBranch;

    if (statementMethod === "Summary") {
      url = "reports/GetExpenseSummary?";
    }
    if (statementMethod === "VATInvoice") {
      url = "reports/GetExpenseVATInvoice?";
    }
    let reportUrl =
      Utils.GetServiceUrl() +
      url +
      "branchId=" +
      branchId +
      "&businessId=" +
      localSettings.business.id +
      "&paymentType=" +
      (filterByPaymentType ? vendorPaymentStatus : "") +
      "&startDate=" +
      Utils.GetISODateTimeString(selectedDate[0]) +
      "&endDate=" +
      Utils.GetISODateTimeString(selectedDate[1]) +
      "&token=" +
      localSettings.token +
      "&culture=" +
      CountryHelper.GetAPICulture(localSettings.country.Culture);
    setReportContent(reportUrl); debugger

    setIsLoading(false);
  };
  const onDateChange = (date) => {
    if (!Utils.IsNullOrEmptyArray(date)) {
      var dateArray = [moment(date[0]), moment(date[1])];
      if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
        setMsgText(
          "Please select a valid date range."
        );
        setMsgOpen(true);
      }
      else {
        let dateDiff = dateArray[1].diff(dateArray[0], "days");
        if (dateDiff > ReportMaxDateLimit) {
          setMsgText(
            "Please note that the maximum date range you can select is 366 days. You can choose any start date within the past 366 days, but the end date cannot exceed this limit."
          );

          setMsgOpen(true);
        } else {
          setSelectedDate(dateArray);
        }
      }
    }
  };

  const handleInputStatement = (e) => {
    setStatementMethod(e.target.value);
    setIsDetailed(e.target.value === "Detailed");
  };

  const checkAuthentication = () => {
    if (
      UserHelper.CheckPermission(ExpensesReportPage, navigate, localSettings)
    ) {
      const business = getBusiness();
      if (
        !Utils.IsNullOrEmptyObject(business) &&
        !Utils.IsNullOrEmptyArray(business.branchLocations)
      ) {
        let sortlist = business.branchLocations.sort((a, b) => parseInt(a.branchId) - parseInt(b.branchId));
        setBranches(business.branchLocations);
        if (!Utils.IsNullOrEmptyArray(sortlist)) {
          setFilterByBranch(true);
          setSelectedBranch(sortlist[0].branchId);
        }
      }
    }
    var country = localSettings.country;
    setIsUAEBusiness(CountryHelper.IsBusinessCountryUAE(country));
  };

  useEffect(() => {
    checkAuthentication();
  }, []);

  const handleSelect = (event) => {
    setSelectedBranch(event.target.value);
  };

  const handleEmailClicked = async () => {
    const branchId = selectedBranch;
    setIsLoading(true);
    setMsgOpen(true);
    if (!Utils.IsEmailValid(emailId)) {
      setIsNavigateToLogin(false);
      setIsLoading(false);
      setMsgText("Please enter a valid email ID.");
      setMsgOpen(true);
      return false;
    } else {
      let response = await postAsync("reports/EmailExpense", {
        BusinessId: localSettings.business.id,
        CompanyName: localSettings.business.companyName,
        EmailIds: [emailId],
        IsDetailed: _IsDetailed,
        startDate: selectedDate[0],
        endDate: selectedDate[1],
        branchId: branchId,
        IsAdmin: localSettings.user.role === UserRoles.GlobalAdmin,
      });

      setIsNavigateToLogin(response.isNavigateToLogin);
      let errorMsg = "Unable to process your request.";
      if (response.error) {
        errorMsg = response.errorMessage;
      } else if (response.data && response.data.success) {
        errorMsg = "Email sent successfully.";
        setOpen(false);
      }
      setMsgText(errorMsg);
      setIsLoading(false);
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLabelClear = (event) => {
    setSelectedBranch(""); // Set the value to an empty string to clear the selection
    setSelectedBranch(event.target.value);
  }

  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" sx={{ fontSize: "18px", fontWeight: "600" }}>
            {"Send expense to your email"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Stack direction="row" justifyContent="end" spacing={1} className="font-size-14">
                <FormControl fullWidth>
                  <TextField
                    label="Email"
                    value={emailId}
                    type="email"
                    onChange={(e) => {
                      setEmailId(e.target.value);
                    }}
                  />
                </FormControl>
                <Stack
                  direction="row"
                  xs={12}
                  justifyContent="end"
                  alignSelf="center"
                >
                  <FormControl>
                    <Button
                      sx={{ height: "53px" }}
                      variant="contained"
                      className="btn btn-primary"
                      onClick={handleEmailClicked}
                      autoFocus
                    >
                      Send
                    </Button>
                  </FormControl>
                </Stack>
              </Stack>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button className="btn btn-secondary" onClick={handleClose}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Box>
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.InvoiceReport} />
            <Grid xs={12} className="content-sec">
              <Grid container direction="row" className="">
                <ReportMenuItems
                  selectedMenu={SettingsMenuList.BusinessReports.Expenses}
                />
                <Grid xs={12} md={9}>
                  <Grid spacing={2} className="form-sec pb-0">

                    <Stack
                      direction="row"
                      spacing={1}
                      style={{ height: "100%", width: "100%" }}
                      justifyContent="space-between"
                      className="card white-bg p-1 sticky-search-form"
                    >
                      <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                      >
                        <FormControl
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          className="font-size-14"
                          sx={{ width: "300px" }}
                        >
                          <InputLabel id="Branch-label">Filter by Branch</InputLabel>
                          <Select
                            value={selectedBranch}
                            onChange={handleSelect}
                            label="Branch Name"
                            InputLabelProps={{ shrink: true }}
                            style={{
                              height: "46px",
                            }}
                          >
                            {branches.map((branch, index) => (
                              <MenuItem key={index} value={branch.branchId}>
                                {branch.branchName}
                              </MenuItem>
                            ))}
                          </Select>
                          <Button className="clearBtn" title="Clear" onClick={handleLabelClear}><ClearIcon /></Button>
                        </FormControl>
                      </Stack>
                      <Stack direction="row" className="w-100" justifyContent="end" spacing={1}>
                        <DateRangePicker
                          showLeadingZeros={true}
                          onChange={onDateChange}
                          maxDate={new Date()}
                          value={selectedDate}
                          locale={CountryHelper.GetDateCulture(localSettings.country.Culture)}
                          clearIcon={null}
                          calendarIcon={
                            <CalendarMonthOutlinedIcon
                              style={{
                                "font-size": "24px",
                                "align-self": "center",
                                color: "#666666",
                              }}
                            />
                          }
                        />
                        <FormControl sx={{ alignSelf: "center" }}>
                          <Button
                            className="btn btn-secondary"
                            variant="contained"
                            onClick={handleClickOpen}
                          >
                            <SendIcon fontSize="large" /> &nbsp;
                            Send Email
                          </Button>
                        </FormControl>
                        <FormControl sx={{ alignSelf: "center" }}>
                          <Button
                            className="btn btn-secondary"
                            variant="contained"
                            onClick={handleSubmit}
                          >
                            <VisibilityIcon fontSize="large" /> &nbsp;
                            View Expenses
                          </Button>
                        </FormControl>
                      </Stack>
                    </Stack>

                    <Stack
                      spacing={2}
                      justifyContent="space-between"
                      className="card white-bg mt-1 font-size-14"
                      padding={1}
                      direction="row"
                    >
                      <RadioGroup
                        value={statementMethod}
                        onChange={(e) => handleInputStatement(e)}
                        InputLabelProps={{ shrink: true }}
                      >
                        <Stack direction="row" spacing={10}>
                          <FormControlLabel
                            value={"Summary"}
                            control={<Radio />}
                            label="Summary"
                          />
                          <FormControlLabel
                            value={"Detailed"}
                            control={<Radio />}
                            label="Detailed"
                          />
                          {isUAEBusiness === true && (
                            <FormControlLabel
                              value={"VATInvoice"}
                              control={<Radio />}
                              label="VAT Invoice"
                            />)}
                        </Stack>
                      </RadioGroup>
                      {/* filter by payment status */}
                      {statementMethod === "Detailed" && (
                        <Stack
                          direction="row"
                          spacing={2}
                          alignItems="center"
                          justifyContent="end"
                          marginTop={1}
                        >
                          {filterByPaymentType && (
                            <FormControl
                              fullWidth
                              variant="outlined"
                              margin="dense"
                              className="font-size-14"
                            >
                              <InputLabel id="Branch-label">Payment Status</InputLabel>
                              <Select
                                value={vendorPaymentStatus}
                                onChange={(e) => setVendorPaymentStatus(e.target.value)}
                                label="Payment Status"
                                InputLabelProps={{ shrink: true }}
                                style={{ height: "50px", width: "240px" }}
                              >
                                <MenuItem value="Paid">Paid</MenuItem>
                                <MenuItem value="Unpaid">Unpaid</MenuItem>
                              </Select>
                            </FormControl>
                          )}

                          <Switch
                            checked={filterByPaymentType}
                            onChange={handleFilterByPaymentChange}
                          />

                          <Typography
                            variant="h6"
                            style={{ "white-space": "nowrap", marginLeft: "0" }}
                            alignSelf="center"
                          >
                            Filter by payment Status
                          </Typography>
                        </Stack>)}
                    </Stack>
                    <iframe
                      className="reportIframe card white-bg mt-1"
                      src={reportContent}
                      style={{
                        width: "100%",
                        height: "calc(100vh - 255px)",
                        marginBottom: "100px"
                      }}
                    ></iframe>

                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Container>
  );
};

export default ExpensesReport;
